import React from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    ActionIcon,
} from '@mantine/core';

import {
    IconFlag,
    IconCornerDownRight,
    IconSquareRoundedArrowUp,
    IconTrendingUp
} from '@tabler/icons'

const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
    },
    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
}));


export function CommentCard({ postedAt, body, author }) {
    const { classes } = useStyles();
    return (
        <Paper withBorder radius="md" className={classes.comment}>
            <Group>
                <Avatar src={author.src} alt={author.name} radius="xl" />
                <div>
                    <Text size="sm">{author.name}</Text>
                    <Text size="xs" color="dimmed">
                        {postedAt}
                    </Text>
                </div>
            </Group>
            <TypographyStylesProvider className={classes.body}>
                <div
                    className={classes.content}
                    dangerouslySetInnerHTML={{ __html: body }}
                />
            </TypographyStylesProvider>
            <br/>
            <Group id="mediaGallerySection" position="apart" className={classes.mediaGalleryBtns}>
                <ActionIcon variant="transparent" size="lg">
                    43
                    <IconTrendingUp color={"black"} size={35} stroke={2.0}/>
                </ActionIcon>
                <ActionIcon variant="transparent" size="md">
                    <IconFlag color={"black"} size={35} stroke={2.0}/>
                </ActionIcon>
            </Group>
    </Paper>
  );
}
